import { Controller } from "@hotwired/stimulus"

// Manages the vertical stack of Trip cards on the order form. Clicking
// "+ Add Trip" appends a fresh card from the cached template and rewrites
// __INDEX__/__INDEX_LABEL__ to a unique slot. Existing trips carry fixed
// Helm labels ("Trip 94.1", no rowLabel target); only NEW rows have a
// rowLabel and get numbered "Trip #N" past labelOffset (the count of
// existing trips on the order).
export default class extends Controller {
  static targets = ["list", "rowTemplate", "row", "rowLabel"]
  static values = { labelOffset: { type: Number, default: 0 } }

  add(event) {
    event.preventDefault()
    // The slot derives from the live DOM (max data-leg-index + 1), never
    // from per-instance state: a counter hands out duplicate legs[] indexes
    // if the controller is ever bound twice (e.g. Turbo appending a second
    // JS bundle after a deploy), and two rows sharing a name= mean the
    // later row silently overwrites the earlier one on submit.
    const slot = this.rowTargets.reduce(
      (max, row) => Math.max(max, Number(row.dataset.legIndex) || 0), -1
    ) + 1
    const label = this.rowLabelTargets.length + 1 + this.labelOffsetValue
    const html = this.rowTemplateTarget.innerHTML
      .replace(/__INDEX__/g, slot)
      .replace(/__INDEX_LABEL__/g, label)
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-order-legs-target='row']")
    if (!row) return

    if (this.rowTargets.length === 1) {
      // Last trip — keep the card but blank its inputs so OrderForm treats
      // it as empty (an order needs at least one trip to validate).
      row.querySelectorAll("input, select, textarea").forEach((el) => {
        if (el.type === "hidden") return
        if (el.type === "checkbox") { el.checked = false; return }
        el.value = ""
      })
      return
    }

    row.remove()
    this.relabel()
  }

  relabel() {
    this.rowLabelTargets.forEach((label, i) => {
      label.textContent = i + 1 + this.labelOffsetValue
    })
  }
}
